import { CreateReferalData, DocEntity } from '../../api/createReferal';

export type ConfirmParam = {
    s_name?: string;
    name?: string;
    id?: number;
    groupId?: string;
    note?: string;
    eka_note?: string;
    refer_to_eka?: boolean;
    doc: DocEntity[];
    campaign?: boolean;
    referred_doctor_url?: string;
    referred_doctor_oid?: string;
};

export function toCreateReferalData({
    data,
    ptId,
}: {
    data: ConfirmParam;
    ptId: string;
}): CreateReferalData {
    const {
        s_name,
        name,
        id,
        groupId,
        note,
        doc,
        campaign,
        eka_note,
        refer_to_eka,
        referred_doctor_url,
        referred_doctor_oid,
    } = data;

    return {
        name,
        s_name,
        id,
        group_id: groupId,
        patientid: ptId,
        note,
        doc,
        campaign,
        eka_note,
        refer_to_eka,
        referred_doctor_url,
        referred_doctor_oid,
        created_at: new Date().toISOString(),
    };
}
